/* eslint-disable @typescript-eslint/no-explicit-any */

import Trie from 'src/Trie';

export default function shallowMemoize<Fn extends (...args: any[]) => any>(
  makeData?: Fn,
): Fn {
  const trie = new Trie(
    true,
    makeData ? (args): ReturnType<Fn> => makeData(...args) : undefined,
  );

  return function () {
    // eslint-disable-next-line prefer-rest-params
    return trie.lookupArray(arguments);
  } as Fn;
}
